var _line, _g, _g2, _line2, _g3, _g4, _rect, _g5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFrameSizeWallArc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "228px",
    height: "232px",
    viewBox: "0 0 607.4 619",
    enableBackground: "new 0 0 607.4 619",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 3.1557,
    x1: 0,
    y1: 607.4,
    x2: 520.1,
    y2: 607.4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M533.3,608.4v-13.3h8.7v1.5H535v4.3h6.9v1.5H535v6.1H533.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M544.1,608.4v-13.3h1.7V607h6.2v1.5H544.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M554.4,605.3c-0.5-1-0.8-2.2-0.8-3.5s0.3-2.5,0.8-3.5c0.5-1,1.3-1.9,2.3-2.5c1-0.6,2.2-0.9,3.5-0.9 s2.4,0.3,3.5,0.9c1,0.6,1.8,1.4,2.4,2.5s0.8,2.2,0.8,3.5s-0.3,2.5-0.8,3.5s-1.3,1.9-2.4,2.5c-1,0.6-2.2,0.9-3.5,0.9 s-2.4-0.3-3.5-0.9C555.8,607.2,555,606.4,554.4,605.3z M555.3,601.8c0,1,0.2,2,0.6,2.8s1,1.5,1.7,1.9c0.7,0.5,1.6,0.7,2.6,0.7 s1.8-0.2,2.6-0.7s1.3-1.1,1.7-1.9c0.4-0.8,0.6-1.7,0.6-2.8c0-1.6-0.5-2.9-1.4-3.9c-0.9-1-2.1-1.5-3.6-1.5c-1.5,0-2.7,0.5-3.6,1.5 C555.8,598.9,555.3,600.2,555.3,601.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M569.7,605.3c-0.5-1-0.8-2.2-0.8-3.5s0.3-2.5,0.8-3.5c0.5-1,1.3-1.9,2.3-2.5c1-0.6,2.2-0.9,3.5-0.9 s2.4,0.3,3.5,0.9c1,0.6,1.8,1.4,2.4,2.5s0.8,2.2,0.8,3.5s-0.3,2.5-0.8,3.5s-1.3,1.9-2.4,2.5c-1,0.6-2.2,0.9-3.5,0.9 s-2.4-0.3-3.5-0.9C571.1,607.2,570.3,606.4,569.7,605.3z M570.6,601.8c0,1,0.2,2,0.6,2.8s1,1.5,1.7,1.9c0.7,0.5,1.6,0.7,2.6,0.7 s1.8-0.2,2.6-0.7s1.3-1.1,1.7-1.9c0.4-0.8,0.6-1.7,0.6-2.8c0-1.6-0.5-2.9-1.4-3.9c-0.9-1-2.1-1.5-3.6-1.5c-1.5,0-2.7,0.5-3.6,1.5 C571.1,598.9,570.6,600.2,570.6,601.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M584.8,608.4v-13.3h5.4c1.2,0,2.2,0.4,3,1.1s1.2,1.7,1.2,2.9c0,0.6-0.1,1.1-0.3,1.6 c-0.2,0.5-0.5,0.9-0.8,1.2c-0.3,0.3-0.7,0.6-1.1,0.8c-0.4,0.2-0.9,0.3-1.3,0.3l3.6,5.4h-2l-3.4-5.3h-2.7v5.3H584.8z M586.4,601.7 h3.5c0.8,0,1.4-0.2,1.9-0.7c0.5-0.5,0.8-1.1,0.8-1.8s-0.2-1.4-0.7-1.8s-1.1-0.7-1.9-0.7h-3.5V601.7z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 121.9,
    y: 138.9,
    fill: "none",
    stroke: "#616261",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    width: 280.2,
    height: 389
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 162,
    fill: "none",
    stroke: "#616261",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    width: 234,
    height: 342.8
  }))), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 3.1557,
    x1: 0,
    y1: 16.9,
    x2: 520.1,
    y2: 16.9
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M533,24.1c-0.4-0.9-0.5-1.8-0.5-2.8s0.2-1.9,0.5-2.8c0.4-0.9,0.8-1.6,1.5-2.2c0.6-0.6,1.3-1.1,2.2-1.4 s1.7-0.5,2.7-0.5c2.1,0,3.8,0.9,5.1,2.6l-1.4,0.8c-0.4-0.6-0.9-1.1-1.6-1.4s-1.4-0.5-2.1-0.5c-1.5,0-2.7,0.5-3.7,1.5 s-1.5,2.3-1.5,3.9c0,1,0.2,2,0.7,2.8s1.1,1.5,1.8,1.9s1.7,0.7,2.6,0.7c0.7,0,1.4-0.2,2.1-0.5s1.2-0.8,1.6-1.4l1.4,0.8 c-1.3,1.8-3,2.7-5.1,2.7c-1,0-1.8-0.2-2.7-0.5s-1.6-0.8-2.2-1.4S533.3,25,533,24.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M546.5,28V14.7h8.7v1.5h-7.1v4.3h6.9v1.5h-6.9v4.6h7.1V28H546.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M557.9,28V14.7h1.7V28H557.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M562.4,28V14.7h1.7v11.9h6.2V28H562.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M572.5,28V14.7h1.7V28H572.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M577.3,28V14.7h1.7l7.7,10.4V14.7h1.7V28h-1.6L579,17.3V28H577.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M591.4,24.2c-0.4-0.9-0.5-1.8-0.5-2.8s0.2-2,0.5-2.8c0.4-0.9,0.8-1.6,1.5-2.2c0.6-0.6,1.3-1.1,2.2-1.4 c0.8-0.3,1.7-0.5,2.7-0.5c2.1,0,3.9,0.8,5.2,2.5l-1.3,0.8c-0.4-0.6-1-1-1.7-1.3c-0.7-0.3-1.4-0.5-2.2-0.5c-1.5,0-2.7,0.5-3.7,1.5 c-1,1-1.5,2.3-1.5,3.9c0,1,0.2,2,0.7,2.8c0.4,0.8,1.1,1.5,1.8,1.9c0.8,0.5,1.7,0.7,2.6,0.7c0.7,0,1.4-0.1,2.1-0.4 c0.6-0.3,1.2-0.6,1.5-1v-2.7h-4.6v-1.5h6.2v4.8c-0.6,0.7-1.4,1.3-2.3,1.7c-0.9,0.4-1.9,0.6-2.9,0.6c-0.9,0-1.8-0.2-2.7-0.5 c-0.8-0.3-1.6-0.8-2.2-1.4C592.3,25.8,591.8,25,591.4,24.2z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.75,
    fill: "#B2B2B2",
    stroke: "#717070",
    strokeWidth: 0.6552,
    strokeMiterlimit: 10,
    enableBackground: "new    ",
    points: " 510.4,60.7 521.1,51.1 3.3,51.1 13.3,60.7 508.9,60.7  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 18.9,
    opacity: 0.7,
    fill: "#C6C6C6",
    stroke: "#717070",
    strokeWidth: 0.6206,
    strokeMiterlimit: 10,
    enableBackground: "new    ",
    width: 518.1,
    height: 32.1
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 16.9,
    fill: "none",
    stroke: "#464545",
    strokeWidth: 3.1557,
    width: 520.1,
    height: 590.5
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 3,
    x1: 507.5,
    y1: 100,
    x2: 16.6,
    y2: 100
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "504.9,91 520.4,100 504.9,108.9  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "19.2,91 3.6,100 19.2,108.9  "
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrameSizeWallArc);
export default __webpack_public_path__ + "static/media/FrameSize_wall_arc.896e3f225b671076b4be94dba5bf456c.svg";
export { ForwardRef as ReactComponent };